import React, { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';

import { ReactComponent as FacilityArrow } from '../../../assets/icons/profile/facilityNavigate.svg';
import { ReactComponent as PriceUp } from '../../../assets/icons/profile/price-up.svg';
import { ReactComponent as ScrollLeftArrow } from '../../../assets/icons/profile/scroll-left-arrow.svg';
import { brandIcons, brandText } from '../../../config/branding';
import { RevenueCardData } from '../../../interface/profile.interface';
import { useAppDispatch } from '../../../redux/hooks';
import { setNotificationDetails } from '../../../redux/slice/NotificationSlice';
import profile from '../../../utils/api/profile';

/**
 * View the revenue history list for scroll function
 * @returns
 */
function RevenueHistory() {
  const dispatch = useAppDispatch();
  const sliderReference = useRef<Slider>(null);
  const settings = {
    infinite: false,
    slidesToShow: 5, // Show 5 cards at a time
    slidesToScroll: 2,
    autoplay: false,
    autoplaySpeed: 2000,
    arrows: false, // We will handle arrows manually
    speed: 500,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const [revenueCardData, setRevenueCardData] = useState<RevenueCardData[]>([]);

  /**
   * moveLeft
   */
  const moveLeft = () => {
    if (sliderReference.current) {
      sliderReference.current.slickPrev(); // Moves to previous slide
    }
  };

  /**
   * Function to handle moving the slider to the right
   */
  const moveRight = () => {
    if (sliderReference.current) {
      sliderReference.current.slickNext(); // Moves to next slide
    }
  };

  /**
   * Function to fetch revenue history
   */
  const handleFetchRevenueHistory = async () => {
    try {
      const response = await profile.getRevenueHistory();
      if (response.data.length) {
        setRevenueCardData(
          response.data.map((revenue: any) => ({
            stationTitle: revenue?.chargingStation?.name || '-',
            stationNumber: '', // To-do -> Need to confirm with dinesh bro
            revenueAmount: revenue?.debitAmount?.toFixed(2) || 0,
            currency: brandText.currency,
            growth: `${revenue?.percentageRevenueIncrease?.toFixed(2) || 0}%`,
            growthDescription: 'Than last month',
            icon: <PriceUp />,
          })),
        );
      }
    } catch (error: any) {
      dispatch(
        setNotificationDetails({
          type: 'error',
          notificationDetails: {
            statusCode: error?.response?.data?.code || 200,
            message: error?.response?.data?.message || 'Something went wrong!',
          },
        }),
      );
    }
  };

  useEffect(() => {
    handleFetchRevenueHistory();
  }, []);

  return (
    <div className="revenue-history">
      <div className="revenue-history-header">
        <div className="revenue-left">
          <brandIcons.withdrawalHistoryIcon />
        </div>
        <div className="revenue-title">Revenue History</div>
        <div className="revenue-right">
          <span role="presentation" className="scroll-left" onClick={moveLeft}>
            <ScrollLeftArrow />
          </span>
          <span role="presentation" className="scroll-right" onClick={moveRight}>
            <FacilityArrow />
          </span>
        </div>
      </div>
      <div className="revenue-cards">
        <div className="cards-sliders">
          <Slider
            ref={sliderReference}
            infinite={settings.infinite}
            slidesToShow={settings.slidesToShow}
            slidesToScroll={settings.slidesToScroll}
            autoplay={settings.autoplay}
            autoplaySpeed={settings.autoplaySpeed}
            arrows={settings.arrows}
            speed={settings.speed}
            responsive={settings.responsive}>
            {revenueCardData.map((item) => (
              <div className="card-content">
                <div className="card-title">
                  <div className="station-details">
                    <p className="station-title">{item.stationTitle}</p>
                    <p className="station-number">{item.stationNumber}</p>
                  </div>
                  <div className="revenue-value">
                    <p className="revenue-term">Monthly Revenue</p>
                    <div className="revenue-amount">
                      <p>
                        <brandIcons.dollarCurrency />
                      </p>
                      <p className="price">{item.revenueAmount}</p>
                      <p>{`(${item.currency})`}</p>
                    </div>
                  </div>
                </div>
                <div className="card-bottom">
                  <p>{item.growth}</p>
                  <p>{item.growthDescription}</p>
                  <span>{item.icon}</span>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
}

export default RevenueHistory;
